import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const exchange: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M14-2.75v1.5a.24.24 0 0 1-.078.172.2.2 0 0 1-.172.078H3V.5q0 .106-.078.172A.22.22 0 0 1 2.75.75a.3.3 0 0 1-.187-.078l-2.485-2.5A.23.23 0 0 1 0-2c0-.07.023-.133.078-.187l2.5-2.5a.24.24 0 0 1 .172-.063q.106 0 .172.078.076.066.078.172V-3h10.75q.106 0 .172.078.076.066.078.172m-.062-4.437q.06.081.062.187a.24.24 0 0 1-.062.172l-2.5 2.5a.25.25 0 0 1-.188.078.23.23 0 0 1-.172-.078A.23.23 0 0 1 11-4.5V-6H.25a.23.23 0 0 1-.172-.078A.23.23 0 0 1 0-6.25v-1.5c0-.07.023-.129.078-.172C.128-7.972.188-8 .25-8H11v-1.5q0-.106.063-.172a.26.26 0 0 1 .187-.078.3.3 0 0 1 .188.078zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 9.75)"
    />
  ),
  svgProps: {
    height: "10.5",
    width: "14",
  }
};